import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { memberListEditModal } from '../../../validation/yupSchema';
import { callAdminUpdateUser } from '../../../api-services/index';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';

const MamberEditModal = ({
  setOpenMemberEditModal,
  openMemberEditModal,
  setMemberEditModalData,
  memberEditModalData,
}) => {
  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(memberListEditModal),
    mode: 'onSubmit',
  });

  const { isLoading, mutateAsync } = useMutation(
    'update-user',
    callAdminUpdateUser,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
        }).then(() => {
          queryClient.invalidateQueries('admin-member-listing');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: 'Error!',
          text: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const submitEditedMember = async (value) => {
    let payload = {
      uuid: memberEditModalData.uuid,
      name: value.name,
      phone: value.phone,
      action_type: 'update',
    };
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (memberEditModalData && Object.keys(memberEditModalData).length > 0) {
      reset({
        name: memberEditModalData?.name,
        phone: memberEditModalData?.phone,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberEditModalData]);

  const handleClose = () => {
    setOpenMemberEditModal(false);
    setMemberEditModalData({});
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={openMemberEditModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Edit Member</h5>
        </div>
        <div className="body-content-outer modal-body">
          <div className="col-md-12">
            <form
              className="m-0 form-fields"
              onSubmit={handleSubmit(submitEditedMember)}
            >
              <div className="form-group">
                <input
                  {...register('name')}
                  type="text"
                  name="name"
                  maxLength="25"
                  placeholder="Name"
                  className="form-control"
                />
                <p>{errors.name?.message}</p>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={memberEditModalData.email}
                  placeholder="Email"
                  className="form-control"
                  disabled
                />
              </div>

              <div className="form-group">
                <input
                  {...register('phone')}
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  className="form-control"
                />
                <p>{errors.phone?.message}</p>
              </div>

              <div className="form-group text-center mt-4">
                <button type="submit" className="btn btn-dark-blue">
                  {isLoading ? 'loading' : 'Update'}
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleClose()}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MamberEditModal;
